export const GET_IDQ = "GET_IDQ";
export const GET_IDQ_SUCCESS = "GET_IDQ_SUCCESS";
export const GET_IDQ_FAIL = "GET_IDQ_FAIL";

export const ADD_IDQ_SUCCESS = "ADD_IDQ_SUCCESS";
export const ADD_IDQ_FAIL = "ADD_IDQ_FAIL";
export const UPDATE_IDQ_SUCCESS = "UPDATE_IDQ_SUCCESS";
export const DELETE_IDQ_SUCCESS = "DELETE_IDQ_SUCCESS";
